import { getEnvConfig } from '../config';

// start : remove
export const API_BASE_URL = getEnvConfig().apiUrl;
export const API_PATHS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout'
  },
  USER: {
    PROFILE: '/user/profile',
    UPDATE: '/user/update'
  }
} as const;
// end : remove


export const AUTH_API_PATHS = {
  REFRESH_TOKEN: '/auth/refresh-token',
} as const;

export const CONTENT_API_PATHS = {
  HISTORY_VIDEO: '/dashboard/get-history-videos',
  FAV_VIDEO: '/dashboard/get-fav-videos',
  DASHBOARD: '/dashboard/get-user-dashboard',
  UPDATE_STUDENT_NOTICE_READ_STATUS: '/dashboard/update-student-notice-read-status',
  EXAM: '/dashboard/get-exams',
  TEST: '/get-test-exams',
  TIMELINE: '/get-timeline',
  UG_DEGREES: '/get-all-ug-degrees',
  GET_SERIES: "/get-series",
  GET_PUBLIC_VIDEO: "/get-public-video",
  GET_PRIVATE_VIDEO_COMMENTS: "/get-private-video-comments",
  GET_PUBLIC_VIDEO_COMMENTS: "/get-public-video-comments",
} as const;

export const USER_API_PATHS = {
  GET_PROILE: '/user/get-profile',
  UPDATE_PROFILE: '/user/update-profile',
  UPDATE_BSS_FORM: '/create-or-update-bss-form',
  UPLOAD_IMAGE: '/upload-image',
  CLAIM_CERTIFICATE: "/claim-certificate",
  SEND_EMAIL_OTP: "/user/send-email-otp",
  VERIY_EMAIL_OTP: "/user/verify-email-otp",
  MARK_CERTIFICATR_RECEIVER: "/mark-certificate-received",
  SET_SERIES_WATCH_LATER_DATE: "/set-series-watch-later-date",
  GET_INVOICE: "/payment/get-invoice",
  START_SERIES: "/start-series",
  /** POST body: seriesId, videoDocId, isWelcomeSeries, isPGCourseSeries, isSubscribedSeries, isWatched */
  MARK_SERIES_VIDEO_WATCH: "/mark-series-video-watch",
  /** GET `.../:subscriptionGroupId` — series for a subscription group */
  SERIES_BY_SUBSCRIPTION_GROUP: "/subscriptions/series-by-subscription-group",
  TOGGLE_FAVOURITE_VIDEO: "/toggle-favourite-video",
  UPDATE_VIDEO_LIKE_DISLIKE: "update-video-like-dislike",
  REPORT_PRIVATE_VIDEO_QUERY: "/report-private-video-query",
  REPORT_PUBLIC_VIDEO_QUERY: "/report-public-video-query",
  ADD_VIDEO_COMMENT: "/add-video-comment",
  ADD_COMMENT_REPLY: "/add-comment-reply",
  ADD_REPLY_TO_REPLY: "/add-reply-of-reply",
  UPDATE_COMMENT_LIKE_OR_DISLIKE_COUNT: "/update-comment-like-or-dislike-count",
  UPDATE_REPLY_LIKE_OR_DISLIKE_COUNT: "/update-reply-like-or-dislike-count",
  UPDATE_VIDEO_WATCH_COUNT: "/update-video-watch-count",
  UPDATE_USER_PURCHASE_CONTENT: "update-user-purchase-content",
  UPDATE_WELCOME_SERIES_CONTENT: "update-welcome-series-content",
  VERIY_FREE_EXTENSION: "/verify-free-extension",
  ADD_COURSE_FREE_EXTENSION:"/add-course-free-extension",
  UPDATE_PRIVATE_VIDEO_COUNT: "update-private-video-view-count",
  UPDATE_PUBLIC_VIDEO_COUNT: "update-public-video-view-count",
  GET_COURSES: '/get-courses',
  CHECK_ELIGIBILITY_FOR_EXAM: "/check-eligibility-for-exam",
  CHECK_ELIGIBILITY_FOR_TEST_EXAM: "/check-eligibility-for-test-exam",
  GET_QUESTION_BANK: "/get-question-bank",
  GET_TEST_QUESTION_BANK: "/get-test-question-bank",
  UPDATE_EXAM_TIMINGS: "/update-exam-timings",
  UPDATE_TEST_EXAM_TIMINGS: "/update-test-exam-timings",
  UPDATE_EXAM_SUBMITION: "/update-exam-submition",
  UPDATE_TEST_EXAM_SUBMITION: "/update-test-exam-submition",
  UPDATE_EXAM_STRIKE: "/update-exam-strike",
  UPDATE_TEST_EXAM_STRIKE: "/update-test-exam-strike",
  ADD_TO_RESULT: "add-to-result",
  ADD_TO_TEST_RESULT: "add-to-test-result",
  GET_RESULT: "get-result",
  GET_TEST_RESULT: "/get-test-result",
  UPDATE_EXAM_STATUS:"/dashboard/update-exam-status",
  REATTEMPT_EXAM:"/reattempt-exam",
  REATTEMPT_TEST_EXAM:"/reattempt-test-exam",
} as const;


export const PAYMENT_API_PATHS = {
  CREATE_ORDER: '/payment/create-razorpay-order',
  ADD_TENTATIVE_ORDER: '/payment/add-tentative-order',
  CREATE_STRIPE_ORDER_ID: '/payment/create-stripe-order',
  GET_ORDER_BY_ID: "/payment/get-order",
  CREATE_CCAVENUE_PAYMENT_GATEWAY: "/payment/create-ccavenue-payment-gateway",
} as const


export const oldS3BucketLink = "https://emediskill-prod.s3.ap-south-1.amazonaws.com"